module.exports = __webpack_public_path__ + "static/img/logo-w.9cd1ff4f.png";